<template>
    <div style="display: flex; justify-content: space-evenly">
        <div id="Wrapper" class="flexContainerColCenter" style="overflow:auto">
            <h2>{{ $t('pairsTeams.Header') }}</h2>
            <div id="ObererBereich" class="flexContainerRowSB-center">
                <div id="LinkerBereich">
                    <h3>{{ $t('pairsTeams.HeaderOverview') }}</h3>
                    <Grid ref="gridPaareUndTeams"
                          :style="{ width: '500px' }"
                          :data-items="gridDataPaareUndTeamsComputed"
                          :loader="loaderPaareUndTeams"
                          :selected-field="selectedFieldPaareUndTeams"
                          @rowclick="onRowClickedPaareUndTeams"
                          :columns="columnsPaareUndTeams">
                        <grid-norecords>{{ $t('pairsTeams.NotificationNoData') }}</grid-norecords>
                    </Grid>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div id="RechterBereich">
                    <h3>{{ $t('pairsTeams.HeaderAssignments') }}</h3>
                    <div>
                        <radiogroup :data-items="dataItemsRadioGroup" :layout="'horizontal'" @change="handleChangeRadioGroup" :value="checked" />
                        <br />
                        <div class="k-form k-form-horizontal">
                            <div class="k-form-field">
                                <label v-if="selectedPrimFormenarten !== 8" for="Teilnehmer1" class="k-form-label">{{ $t('pairsTeams.LabelParticipant1') }}</label>
                                <label v-if="selectedPrimFormenarten === 8" for="Teilnehmer1" class="k-form-label">{{ $t('pairsTeams.LabelParticipant1Hosinsul') }}</label>
                                <div class="k-form-field-wrap">
                                    <combobox :style="{ width: '340px' }"
                                              :data-items="comboDataTeilnehmerAll1"
                                              :text-field="'vornameName'"
                                              :data-item-key="'prim'"
                                              :value-field="'prim'"
                                              :value-primitive="true"
                                              :filterable="true"
                                              @filterchange="filterChange1"
                                              @change="handleChangeTeilnehmer1"
                                              :value="selectedPrimTeilnehmer1"
                                              :placeholder="$t('pairsTeams.LabelAthletePlaceholder')">
                                    </combobox>
                                </div>
                            </div>
                            <br />
                            <div class="k-form-field">
                                <label v-if="selectedPrimFormenarten !== 8" for="Teilnehmer2" class="k-form-label">{{ $t('pairsTeams.LabelParticipant2') }}</label>
                                <label v-if="selectedPrimFormenarten === 8" for="Teilnehmer1" class="k-form-label">{{ $t('pairsTeams.LabelParticipant2Hosinsul') }}</label>
                                <div class="k-form-field-wrap">
                                    <combobox :style="{ width: '340px' }"
                                              :data-items="comboDataTeilnehmerAll2"
                                              :text-field="'vornameName'"
                                              :data-item-key="'prim'"
                                              :value-field="'prim'"
                                              :value-primitive="true"
                                              :filterable="true"
                                              @filterchange="filterChange2"
                                              @change="handleChangeTeilnehmer2"
                                              :value="selectedPrimTeilnehmer2"
                                              :placeholder="$t('pairsTeams.LabelAthletePlaceholder')">
                                    </combobox>
                                </div>
                            </div>
                            <br />
                            <div class="k-form-field" v-if="checked==='9' || checked==='6'">
                                <label for="Teilnehmer3" class="k-form-label">{{ $t('pairsTeams.LabelParticipant3') }}</label>
                                <div class="k-form-field-wrap">
                                    <combobox :style="{ width: '340px' }"
                                              :data-items="comboDataTeilnehmerAll3"
                                              :text-field="'vornameName'"
                                              :data-item-key="'prim'"
                                              :value-field="'prim'"
                                              :value-primitive="true"
                                              :filterable="true"
                                              @filterchange="filterChange3"
                                              @change="handleChangeTeilnehmer3"
                                              :value="selectedPrimTeilnehmer3"
                                              :placeholder="$t('pairsTeams.LabelAthletePlaceholder')">
                                    </combobox>
                                </div>
                            </div>
                            <br />
                            <div id="Buttons">
                                <div v-if="visisbleTextNeuanlage">{{ $t('pairsTeams.ButtonNewText') }}</div>
                                <kbutton title="$t('pairsTeams.buttonNew')" :theme-color="'primary'" @click="onNeuClick">
                                    {{ $t('pairsTeams.buttonNew') }}
                                </kbutton>
                                &nbsp;
                                <kbutton title="$t('pairsTeams.buttonSave')" :theme-color="'primary'" @click="onSpeichernClick">
                                    {{ $t('pairsTeams.buttonSave') }}
                                </kbutton>
                                &nbsp;
                                <kbutton title="$t('pairsTeams.buttonCancel') " :theme-color="'primary'" @click="onAbbrechenClick">
                                    {{ $t('pairsTeams.buttonCancel') }}
                                </kbutton>
                                &nbsp;
                                <kbutton title="$t('pairsTeams.buttonDelete')" :theme-color="'primary'" @click="onLoeschenClick">
                                    {{ $t('pairsTeams.buttonDelete') }}
                                </kbutton>
                            </div>
                            <br />
                        </div>
                    </div>
                </div>
            </div>
            <k-dialog v-if="visibleDeleteDialog" :title="$t('pairsTeams.NotificationDeleteTitle')" @close="toggleDeleteDialog">
                <p :style="{ margin: '25px', textAlign: 'center' }">{{ $t('pairsTeams.NotificationDelete') }}</p>
                <dialog-actions-bar>
                    <kbutton @click='onDeleteData'>{{ $t('pairsTeams.ButtonOK') }}</kbutton>
                    <kbutton @click='toggleDeleteDialog'>{{ $t('pairsTeams.ButtonCancel') }}</kbutton>
                </dialog-actions-bar>
            </k-dialog>
            <NotificationGroup :style="{
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            'align-items': 'flex-start'
            }">
                <Fade :appear="successSpeichernNeu">
                    <Notification v-if="successSpeichernNeu" :type="{ style: 'success', icon: true }">
                        <span>{{ $t('pairsTeams.NotificationSaveNew') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorSpeichernNeu">
                    <Notification v-if="errorSpeichernNeu" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('pairsTeams.NotificationErrorNew') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="successSpeichernBearbeiten">
                    <Notification v-if="successSpeichernBearbeiten" :type="{ style: 'success', icon: true }">
                        <span>{{ $t('pairsTeams.NotificationSaveEdit') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorSpeichernBearbeiten">
                    <Notification v-if="errorSpeichernBearbeiten" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('pairsTeams.NotificationErrorEdit') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="successLoeschen">
                    <Notification v-if="successLoeschen" :type="{ style: 'success', icon: true }">
                        <span>{{ $t('pairsTeams.NotificationSaveDelete') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorLoeschen">
                    <Notification v-if="errorLoeschen" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('pairsTeams.NotificationErrorDelete') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorLoeschenDifference">
                    <Notification v-if="errorLoeschenDifference" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('pairsTeams.NotificationErrorDifference') }}</span>
                    </Notification>
                </Fade>
            </NotificationGroup>
        </div>
    </div>
</template>

<script>
    import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
    import { ComboBox } from '@progress/kendo-vue-dropdowns';
    import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
    import { Button } from "@progress/kendo-vue-buttons";
    import { Fade } from '@progress/kendo-vue-animation';
    import { Notification, NotificationGroup } from '@progress/kendo-vue-notification';
    import { RadioGroup } from '@progress/kendo-vue-inputs';
    import { filterBy } from '@progress/kendo-data-query';
    import config from "@/appdata/config.json";
    import axios from 'axios';
    import store from '@/store/store.js';

    export default {
        components: {
            'k-dialog': Dialog,
            'dialog-actions-bar': DialogActionsBar,
            Grid: Grid,
            "grid-norecords": GridNoRecords,
            "grid-toolbar": GridToolbar,
            'combobox': ComboBox,
            radiogroup: RadioGroup,
            kbutton: Button,
            Fade,
            Notification,
            NotificationGroup,
            store
        },
        data: function () {
            return {
                refVereine: 0,
                baseUrlPaareUndTeams: '',
                baseComboUrlFormenarten: '',
                init: { method: "GET", accept: "application/json", headers: {} },
                pageable: false,
                gridDataPaareUndTeams: [],
                selectedFieldPaareUndTeams: "selectedPaareUndTeams",
                selectedPrimPaareUndTeams: 0,
                comboDataTeilnehmerAll1: [],
                comboDataTeilnehmerAll2: [],
                comboDataTeilnehmerAll3: [],
                comboDataTeilnehmer1: [],
                comboDataTeilnehmer2: [],
                comboDataTeilnehmer3: [],
                baseComboUrl: '',
                baseComboUrl1: '',
                baseComboUrl2: '',
                baseComboUrl3: '',
                selectedPrimTeilnehmer1: 0,
                selectedPrimTeilnehmer2: 0,
                selectedPrimTeilnehmer3: 0,
                selectedPrimFormenarten: 5,//Voreinstellung = Paar
                selectedPrimVereine: 0,
                columnsPaareUndTeams: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "anzeigeName", editable: false, width: 400, title: this.$t('pairsTeams.GridColumnHeaderName') },
                    { field: "refFormenarten", editable: false, hidden: true, width: 100, title: "RefFormenarten" },
                ],
                updatedDataPaareUndTeams: [],
                loaderPaareUndTeams: false,
                totalPaareUndTeams: 0,
                successSpeichernNeu: false,
                errorSpeichernNeu: false,
                successSpeichernBearbeiten: false,
                errorSpeichernBearbeiten: false,
                successLoeschen: false,
                errorLoeschen: false,
                errorLoeschenDifference: false,
                dataItemsRadioGroup: [
                    {
                        label: this.$t('pairsTeams.LabelRadioGroupFamily'),
                        value: "7",
                    },
                    {
                        label: this.$t('pairsTeams.LabelRadioGroupFreestylePair'),
                        value: "4",
                    },
                    {
                        label: this.$t('pairsTeams.LabelRadioGroupFreestyleTeam'),
                        value: "9",
                    },
                    {
                        label: this.$t('pairsTeams.LabelRadioGroupHosinsul'),
                        value: "8",
                    },
                    {
                        label: this.$t('pairsTeams.LabelRadioGroupPair'),
                        value: "5",
                    },
                    {
                        label: this.$t('pairsTeams.LabelRadioGroupTeam'),
                        value: "6",
                    },
                ],
                checked: '5',
                forceComputedUpdate: null,
                flagNeuanlage: false,
                posturlNeu: '',
                deleteurlLoeschen: '',
                visibleDeleteDialog: false,
                visisbleTextNeuanlage: false
            };
        },
        computed: {
            gridDataPaareUndTeamsComputed() {
                if (this.forceComputedUpdate === 'undefined' || this.forceComputedUpdate === null) {
                    return [];
                } else { 
                    return this.gridDataPaareUndTeams.map((item) => ({ prim: item.prim, anzeigeName: item.anzeigeName, refFormenarten: item.refFormenarten, selectedPaareUndTeams: (item.prim === this.selectedPrimPaareUndTeams) }));
                }
            },
        },
        created: function () {
            this.selectedPrimVereine = store.primVerein;
            this.baseUrlPaareUndTeams = config[0].ServiceUrl + config[0].ServiceUrlPort + "/PaareUndTeamsManagement?RefFormenarten=" + this.selectedPrimFormenarten + "&RefVereine=" + store.primVerein;
            this.getDataPaareUndTeams();
            this.getDataTeilnehmer();
        },
        methods: {
            handleChangeTeilnehmer1(event) {
                this.selectedPrimTeilnehmer1 = event.value;
            },
            handleChangeTeilnehmer2(event) {
                this.selectedPrimTeilnehmer2 = event.value;
            },
            handleChangeTeilnehmer3(event) {
                this.selectedPrimTeilnehmer3 = event.value;
            },
            handleChangeRadioGroup(e) {
                this.checked = e.value;
                this.selectedPrimFormenarten = Number(e.value);
                //Grid neu laden
                this.gridDataPaareUndTeams = [];
                this.baseUrlPaareUndTeams = config[0].ServiceUrl + config[0].ServiceUrlPort + "/PaareUndTeamsManagement?RefFormenarten=" + this.selectedPrimFormenarten + "&RefVereine=" + store.primVerein;
                this.getDataPaareUndTeams();
                //Zuweisungen l�schen
                this.selectedPrimTeilnehmer1 = 0;
                this.selectedPrimTeilnehmer2 = 0;
                this.selectedPrimTeilnehmer3 = 0;
                this.baseComboUrl = '';
                this.getDataTeilnehmer();
            },
            onRowClickedPaareUndTeams(event) {
                this.visisbleTextNeuanlage = false;
                this.selectedPrimPaareUndTeams = event.dataItem.prim;
                //this.selectedPrimFormenarten = event.dataItem.refFormenarten;
                if (this.selectedPrimTeilnehmer1 !== this.selectedPrimTeilnehmer2 && this.selectedPrimTeilnehmer1 !== this.selectedPrimTeilnehmer3 && this.selectedPrimTeilnehmer2 !== this.selectedPrimTeilnehmer3) {
                    this.getDataTeilnehmer1();
                    this.getDataTeilnehmer2();
                } else {
                    this.getDataTeilnehmer1();
                    this.getDataTeilnehmer2();
                    this.getDataTeilnehmer3();
                }
            },
            getDataPaareUndTeams: function (initial) {
                this.forceComputedUpdate === null
                console.log("---->", initial);
                const that = this;
                this.loader = true;
                fetch(
                    this.baseUrlPaareUndTeams,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        let total = json["@odata.count"];
                        let data = json["data"];
                        if (json.length !== 0) {
                            this.forceComputedUpdate = new Date().getTime();
                            total = json["@odata.count"];
                            data = json["data"];
                        } else {
                            this.forceComputedUpdate = null;
                        }
                        that.totalPaareUndTeams = total;
                        that.updatedDataPaareUndTeams = [].concat(data);
                        that.gridDataPaareUndTeams = data;
                        this.loaderPaareUndTeams = false;
                    })
                    .finally(() => {
                        this.loaderPaareUndTeams = false;
                    });
            },
            getDataTeilnehmer: function () {
                this.baseComboUrl = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TeilnehmerUndFreigabenByVereinManagement?RefVereine=" + store.primVerein;
                this.comboDataTeilnehmerAll1 = [];
                this.comboDataTeilnehmerAll2 = [];
                this.comboDataTeilnehmerAll3 = [];
                const that = this;
                fetch(this.baseComboUrl, this.init)
                    .then((response) => response.json())
                    .then((json) => {
                        const data = json["data"];
                        that.comboDataTeilnehmerAll1 = data;
                        that.comboDataTeilnehmerAll2 = data;
                        that.comboDataTeilnehmerAll3 = data;
                    });
            },
            getDataTeilnehmer1: function () {
                this.selectedPrimTeilnehmer1 = null;
                this.baseComboUrl1 = config[0].ServiceUrl + config[0].ServiceUrlPort + "/PaareUndTeamsTeilnehmerBySortierungManagement?RefTeilnehmerTeams=" + this.selectedPrimPaareUndTeams + "&Sortierung=1";
                this.comboDataTeilnehmer1 = [];
                const that = this;
                fetch(this.baseComboUrl1, this.init)
                    .then((response) => response.json())
                    .then((json) => {
                        const data = json["data"];
                        that.selectedPrimTeilnehmer1 = data[0].prim;
                    });
            },
            getDataTeilnehmer2: function () {
                this.selectedPrimTeilnehmer2 = null;
                this.baseComboUrl2 = config[0].ServiceUrl + config[0].ServiceUrlPort + "/PaareUndTeamsTeilnehmerBySortierungManagement?RefTeilnehmerTeams=" + this.selectedPrimPaareUndTeams + "&Sortierung=2";
                this.comboDataTeilnehmer2 = [];
                const that = this;
                fetch(this.baseComboUrl2, this.init)
                    .then((response) => response.json())
                    .then((json) => {
                        const data = json["data"];
                        that.selectedPrimTeilnehmer2 = data[0].prim;
                    });
            },
            getDataTeilnehmer3: function () {
                this.selectedPrimTeilnehmer3 = 0;
                this.baseComboUrl3 = config[0].ServiceUrl + config[0].ServiceUrlPort + "/PaareUndTeamsTeilnehmerBySortierungManagement?RefTeilnehmerTeams=" + this.selectedPrimPaareUndTeams + "&Sortierung=3";
                this.comboDataTeilnehmer3 = [];
                const that = this;
                fetch(this.baseComboUrl3, this.init)
                    .then((response) => response.json())
                    .then((json) => {
                        const data = json["data"];
                        that.selectedPrimTeilnehmer3 = data[0].prim;
                    });
            },
            onNeuClick() {
                this.flagNeuanlage = true;
                this.visisbleTextNeuanlage = true;
                //Felder leeren
                this.selectedPrimTeilnehmer1 = 0;
                this.selectedPrimTeilnehmer2 = 0;
                this.selectedPrimTeilnehmer3 = 0;
                this.baseComboUrl = '';
                this.getDataTeilnehmer();
            },
            onSpeichernClick() {
                this.visisbleTextNeuanlage = false;
                //Neuanlage
                if (this.flagNeuanlage === true && this.selectedPrimFormenarten > 0 && this.selectedPrimTeilnehmer1 > 0 && this.selectedPrimTeilnehmer2 > 0 && this.selectedPrimVereine > 0) {
                    if (this.selectedPrimFormenarten === 1 || this.selectedPrimFormenarten === 2 || this.selectedPrimFormenarten === 3 || this.selectedPrimFormenarten === 4 || this.selectedPrimFormenarten === 5 || this.selectedPrimFormenarten === 7 || this.selectedPrimFormenarten === 8) {
                        this.selectedPrimTeilnehmer3 = 0;
                        //6 und 9 sind Teams, alle andere Paare
                    }
                    if (this.selectedPrimTeilnehmer1 !== this.selectedPrimTeilnehmer2 && this.selectedPrimTeilnehmer1 !== this.selectedPrimTeilnehmer3 && this.selectedPrimTeilnehmer2 !== this.selectedPrimTeilnehmer3) {
                        const parameters = {
                            "prim": 0,//Neuanlage
                            "refFormenarten": this.selectedPrimFormenarten,
                            "refTeilnehmer1": this.selectedPrimTeilnehmer1,
                            "refTeilnehmer2": this.selectedPrimTeilnehmer2,
                            "refTeilnehmer3": this.selectedPrimTeilnehmer3,
                            "refVereine": this.selectedPrimVereine,
                        };
                        this.posturlNeu = config[0].ServiceUrl + config[0].ServiceUrlPort + "/InsertTeamsByFormenart"
                        axios.post(this.posturlNeu, parameters)
                            .then((response) => {
                                console.log("----------> success", response);
                                //Grid neu laden
                                this.flagNeuanlage = false;
                                this.gridDataPaareUndTeams = [];
                                this.baseUrlPaareUndTeams = config[0].ServiceUrl + config[0].ServiceUrlPort + "/PaareUndTeamsManagement?RefFormenarten=" + this.selectedPrimFormenarten + "&RefVereine=" + store.primVerein;
                                this.getDataPaareUndTeams();
                                this.showNotificationSuccessSpeichernNeu();
                            })
                            .catch((error) => {
                                console.log("---------> error", error);
                                this.showNotificationErrorSpeichernNeu();
                                this.flagNeuanlage = false;
                                
                            });
                    } else {
                        this.showNotificationErrorDifference();
                    }
                } else if(this.flagNeuanlage === false && this.selectedPrimFormenarten > 0 && this.selectedPrimTeilnehmer1 > 0 && this.selectedPrimTeilnehmer2 > 0 && this.selectedPrimVereine){
                    //L�schen
                    if (this.selectedPrimTeilnehmer1 !== this.selectedPrimTeilnehmer2 && this.selectedPrimTeilnehmer1 !== this.selectedPrimTeilnehmer3 && this.selectedPrimTeilnehmer2 !== this.selectedPrimTeilnehmer3) {
                        this.deleteurlLoeschen = config[0].ServiceUrl + config[0].ServiceUrlPort + "/DeleteTeamsByFormenart"
                        axios.delete(this.deleteurlLoeschen, { data: { prim: this.selectedPrimPaareUndTeams } })
                            .then((response) => {
                                console.log("----------> success", response);
                                //Bearbeitung Speichern bzw. neu unter alten Prim anlegen
                                if (this.selectedPrimFormenarten === 1 || this.selectedPrimFormenarten === 2 || this.selectedPrimFormenarten === 3 || this.selectedPrimFormenarten === 4 || this.selectedPrimFormenarten === 5 || this.selectedPrimFormenarten === 7 || this.selectedPrimFormenarten === 8) {
                                    this.selectedPrimTeilnehmer3 = 0;
                                    //6 und 9 sind Teams, alle andere Paare
                                }
                                const parameters = {
                                    "prim": this.selectedPrimPaareUndTeams,//Bearbeitung
                                    "refFormenarten": this.selectedPrimFormenarten,
                                    "refTeilnehmer1": this.selectedPrimTeilnehmer1,
                                    "refTeilnehmer2": this.selectedPrimTeilnehmer2,
                                    "refTeilnehmer3": this.selectedPrimTeilnehmer3,
                                    "refVereine": this.selectedPrimVereine,
                                };
                                this.posturlNeu = config[0].ServiceUrl + config[0].ServiceUrlPort + "/InsertTeamsByFormenart"
                                axios.post(this.posturlNeu, parameters)
                                    .then((response) => {
                                        console.log("----------> success", response);
                                        //Grid neu laden
                                        this.flagNeuanlage = false;
                                        this.gridDataPaareUndTeams = [];
                                        this.baseUrlPaareUndTeams = config[0].ServiceUrl + config[0].ServiceUrlPort + "/PaareUndTeamsManagement?RefFormenarten=" + this.selectedPrimFormenarten + "&RefVereine=" + store.primVerein;
                                        this.getDataPaareUndTeams();
                                        this.showNotificationSuccessSpeichernBearbeiten();
                                    })
                                    .catch((error) => {
                                        console.log("---------> error", error);
                                        this.showNotificationErrorSpeichernBearbeiten();
                                    });
                            })
                            .catch((error) => {
                                console.log("---------> error", error);
                                this.flagNeuanlage = false;
                                this.showNotificationErrorSpeichernBearbeiten();
                            });
                    } else {
                        this.showNotificationErrorDifference();
                    }
                }
            },
            onAbbrechenClick() {
                this.visisbleTextNeuanlage = false;
                //Grid neu laden
                this.flagNeuanlage = false;
                this.gridDataPaareUndTeams = [];
                this.baseUrlPaareUndTeams = config[0].ServiceUrl + config[0].ServiceUrlPort + "/PaareUndTeamsManagement?RefFormenarten=" + this.selectedPrimFormenarten + "&RefVereine=" + store.primVerein;
                this.getDataPaareUndTeams();
                //Felder leeren
                this.selectedPrimTeilnehmer1 = null;
                this.selectedPrimTeilnehmer2 = null;
                this.selectedPrimTeilnehmer3 = null;
                this.baseComboUrl = '';
                this.getDataTeilnehmer();
            },
            onLoeschenClick() {
                this.visibleDeleteDialog = true;
                this.visisbleTextNeuanlage = false;
            },
            onDeleteData() {
                this.visibleDeleteDialog = !this.visibleDeleteDialog;
                this.deleteurlLoeschen = config[0].ServiceUrl + config[0].ServiceUrlPort + "/DeleteTeamsByFormenart"
                axios.delete(this.deleteurlLoeschen, { data: { prim: this.selectedPrimPaareUndTeams } })
                    .then((response) => {
                        console.log("----------> success", response);
                        //Grid neu laden
                        this.flagNeuanlage = false;
                        this.gridDataPaareUndTeams = [];
                        this.baseUrlPaareUndTeams = config[0].ServiceUrl + config[0].ServiceUrlPort + "/PaareUndTeamsManagement?RefFormenarten=" + this.selectedPrimFormenarten + "&RefVereine=" + store.primVerein;
                        this.getDataPaareUndTeams();
                        //Felder leeren
                        this.selectedPrimTeilnehmer1 = null;
                        this.selectedPrimTeilnehmer2 = null;
                        this.selectedPrimTeilnehmer3 = null;
                        this.baseComboUrl = '';
                        this.getDataTeilnehmer();
                        this.showNotificationSuccessSpeichernLoeschen();
                    })
                    .catch((error) => {
                        console.log("---------> error", error);
                        this.flagNeuanlage = false;
                        this.showNotificationErrorSpeichernLoeschen();
                    });
            },
            toggleDeleteDialog() {
                this.visibleDeleteDialog = !this.visibleDeleteDialog;
            },
            filterChange1(event) {
                this.comboDataTeilnehmerAll1 = this.filterData1(event.filter);
            },
            filterChange2(event) {
                this.comboDataTeilnehmerAll2 = this.filterData2(event.filter);
            },
            filterChange3(event) {
                this.comboDataTeilnehmerAll3 = this.filterData3(event.filter);
            },
            filterData1(filter) {
                const data = this.comboDataTeilnehmerAll1.slice();
                return filterBy(data, filter);
            },
            filterData2(filter) {
                const data = this.comboDataTeilnehmerAll2.slice();
                return filterBy(data, filter);
            },
            filterData3(filter) {
                const data = this.comboDataTeilnehmerAll3.slice();
                return filterBy(data, filter);
            },
            showNotificationSuccessSpeichernNeu() {
                /*Meldung anzeigen*/
                this.successSpeichernNeu = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.successSpeichernNeu = false;
                }, 3000);
            },
            showNotificationErrorSpeichernNeu() {
                /*Meldung anzeigen*/
                this.errorSpeichernNeu = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorSpeichernNeu = false;
                }, 3000);
            },
            showNotificationSuccessSpeichernBearbeiten() {
                /*Meldung anzeigen*/
                this.successSpeichernBearbeiten = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.successSpeichernBearbeiten = false;
                }, 3000);
            },
            showNotificationErrorSpeichernBearbeiten() {
                /*Meldung anzeigen*/
                this.errorSpeichernBearbeiten = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorSpeichernBearbeiten = false;
                }, 3000);
            },
            showNotificationSuccessSpeichernLoeschen() {
                /*Meldung anzeigen*/
                this.successLoeschen = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.successLoeschen = false;
                }, 3000);
            },
            showNotificationErrorSpeichernLoeschen() {
                /*Meldung anzeigen*/
                this.errorLoeschen = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorLoeschen = false;
                }, 3000);
            },
            showNotificationErrorDifference() {
                /*Meldung anzeigen*/
                this.errorLoeschenDifference = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorLoeschenDifference = false;
                }, 3000);
            }
        },
    };
</script>

 Add "scoped" attribute to limit CSS to this component only
<style scoped>
    @import '../css/main.css';
</style>
